export default "__VITE_ASSET__Am7A4xcN__"